import { IVbrickLoggingClientConfig } from './IVbrickLoggingClientConfig';
import { LogLevel } from './LogLevel';

export const DefaultVbrickLoggingClientConfig: IVbrickLoggingClientConfig = {
	bufferTimeSpanMs: 5000,
	logLevel: LogLevel.INFO,
	maxBufferSize: 10,
	numRetries: 3,
	onError: error => console.error('VbrickLoggingClient', error)
};
